import { computed, effect, Injectable, resource, Signal, signal } from '@angular/core';
import { AuthService, User } from '@auth0/auth0-angular';
import { CreateTRPCProxyClient, createTRPCProxyClient, httpBatchLink, httpLink, loggerLink } from '@trpc/client';
import { parse, stringify } from "devalue";
import type { AppRouter } from 'server/src';
import { toSignal } from '@angular/core/rxjs-interop';
import { createRemoteJWKSet, jwtVerify } from 'jose';
const JWKS = createRemoteJWKSet(new URL(window.location.origin + "/.well-known/jwks.json"));


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(public auth: AuthService) {
    auth.getAccessTokenSilently().subscribe(async authJwt => {
      let resp = await fetch(`${window.location.origin}/authorization`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${authJwt}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          service: 'auth',
          permissions: ["admin"]
        })
      });
      let data = await resp.json();
      let retToken = data.token;
      console.log("Received token", retToken);
      this.token.set(retToken);
    });
    this.currentUser = toSignal(auth.user$);
    effect(() => {
      let token = this.token();
      if (token != undefined) {
        this.readyAndAuthenticated.set(true);
      }
    }, {
      allowSignalWrites: true
    });

    effect(() => {
      let tv = this.tokenValue.value();
      console.log("Current user changed", tv);
    });
  }


  private token = signal<string | undefined>(undefined);

  public tokenValue = resource({
    params: () => ({token: this.token()}),           // signal dependency
    loader: async ({params}) => {
      if (params.token == undefined) {
        return undefined;
      }
      const { payload } = await jwtVerify(params.token, JWKS, {
        issuer: "sercom-auth-server",
      });
      return payload;
    }
  });


  private currentUser: Signal<User | null | undefined>;

  privateCreateClient() {
    let d = this;

    let baseUrl = window.location.origin;
    baseUrl = baseUrl.replace("6006", "3003");

    let ret = createTRPCProxyClient<AppRouter>({
      transformer: {
        input: {
          serialize: (object) => stringify(object),
          deserialize: (object) => parse(object),
        },
        output: {
          serialize: (object) => stringify(object),
          deserialize: (object) => parse(object),
        },
      },
      links: [
        // loggerLink({

        // }),
        httpLink({
          url: `${baseUrl}/trpc`,
          headers() {
            return {
              authorization: d.token()
            };
          }
        }),
        // httpBatchLink({
        //   url: `${baseUrl}/trpc`,
        // }),
      ],
    });

    return ret;
  }

  public client: CreateTRPCProxyClient<AppRouter> = this.privateCreateClient();
  public readyAndAuthenticated = signal(false);

  public async test(i: string) {
    let ret = await this.client.test.query(i);
    return ret;
  }
}
